<template lang="pug">
.v-dropdown.dropdown(:class="[localDirection ? 'dropdown--' + localDirection : '', open ? 'open' : '']" @mouseenter="!clickMode ? open = true : null" @mouseleave="!clickMode ? open = false : null")
	.dropdown__btn(@click="clickMode ? open = !open : null")
		slot(name="btn")
	.dropdown__body(ref="body")
		.dropdown__panel
			component.dropdown__title(v-if="title" :is="link ? 'a' : 'span'" :href="link" :type="link ? null : 'button'") {{title}}
			slot(name="content")
</template>

<script>

export default {
	props: {
		direction: {
			type: String,
			default: null
		},

		title: {
			type: String,
			default: null
		},

		link: {
			type: String,
			default: null
		},

		clickMode: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			timeout: null,
			localDirection: null,
			open: false
		}
	},

	watch: {
		direction(state) {
			this.localDirection = state;
		}
	},

	mounted() {
		this.checkDirection();
		window.addEventListener('resize', this.resizeHandler);
		if (this.clickMode) {
			document.addEventListener('click', this.handlerClickOutside);
		}
	},

	unmounted() {
		window.removeEventListener('resize', this.resizeHandler);
		document.removeEventListener('click', this.handlerClickOutside);
	},

	methods: {
		resizeHandler() {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(this.checkDirection, 400);
		},

		checkDirection() {
			this.localDirection = window.innerWidth < this.$refs.body.getBoundingClientRect().left + this.$refs.body.clientWidth ? 'left' : this.direction;
		},

		handlerClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		}
	}
}

</script>